import { defaultBounceElasticity, defaultBounceGravity, defaultBounceHang, defaultBounceVelocity, defaultDecayX, defaultDecayY } from '../assets/constants';
import { bounce } from './create-bounce'
import {
  useControls,
} from "leva";

export function BounceWrapper() {
    const myBounce = useControls({ bounceObj: bounce({ elasticity: defaultBounceElasticity, gravity: defaultBounceGravity, decayX: defaultDecayX, decayY:defaultDecayY, hang: defaultBounceHang, velocity: defaultBounceVelocity})})

    return (
    <>
    </>
  )
}